


















import Vue from 'vue'
import IconGitlab from '@/assets/icons/icon-gitlab.svg'
import IconTwitter from '@/assets/icons/icon-twitter.svg'
import IconMedium from '@/assets/icons/icon-medium.svg'
import IconMusic from '@/assets/icons/icon-music.svg'

export default Vue.extend({
  components: {
    IconGitlab,
    IconTwitter,
    IconMedium,
    IconMusic
  }
})
